module.exports = __webpack_public_path__ + "static/media/runwayHero.6dc93818.jpg";